// Local type definition to avoid dependency on @phosphor/server
export type Color = {
  hue: number;
  chroma: number;
};

export const Color = {
  make: (props: { hue: number; chroma: number }): Color => props,
};
